import { useTranslation } from 'react-i18next';

interface Props {
  onNext: () => void;
}

export default function StepWelcome({ onNext }: Props) {
  const { t } = useTranslation('onboarding');

  return (
    <div
      className="page-enter"
      style={{ textAlign: 'center', padding: 'var(--space-12) 0' }}
    >
      {/* Logo mark */}
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: 'var(--radius-xl)',
          background: 'var(--color-brand)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto var(--space-8)',
        }}
      >
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
          <circle cx="5" cy="11" r="3.5" fill="white" />
          <circle cx="11" cy="11" r="3.5" fill="white" opacity="0.7" />
          <circle cx="17" cy="11" r="3.5" fill="white" opacity="0.4" />
        </svg>
      </div>

      <h1
        style={{
          fontSize: 'var(--text-3xl)',
          fontWeight: 'var(--weight-light)',
          color: 'var(--color-text)',
          marginBottom: 'var(--space-3)',
          letterSpacing: 'var(--tracking-tight)',
        }}
      >
        {t('welcome.title')}
      </h1>

      <p
        style={{
          fontSize: 'var(--text-base)',
          color: 'var(--color-text-secondary)',
          marginBottom: 'var(--space-10)',
          maxWidth: 360,
          margin: '0 auto var(--space-10)',
          lineHeight: 'var(--leading-relaxed)',
        }}
      >
        {t('welcome.subtitle')}
      </p>

      <button
        onClick={onNext}
        style={{
          padding: 'var(--space-3) var(--space-8)',
          background: 'var(--color-brand)',
          color: 'var(--color-text-inverse)',
          border: 'none',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--text-base)',
          fontWeight: 'var(--font-medium)',
          cursor: 'pointer',
          transition: 'background var(--duration-snap) var(--ease-out)',
        }}
      >
        {t('welcome.cta')} →
      </button>
    </div>
  );
}
